import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { getShapeGeoTypes } from 'api/rex/spatial';
import ModalPage from '../explore/layout/ModalPage';
import { MenuItem, Select, TextField } from '@material-ui/core';
import { setShowPasteGeosModal, createShape } from 'store/actions';

const PasteGeosModal = ({
  classes,
  // Props
  selectedGroup,
  showPasteGeosModal,
  //Actions
  setShowPasteGeosModal,
  createShape,
}) => {
  // == useState ==============================

  const [geoType, setGeoType] = useState(null);
  const [pastedGeoIds, setPastedGeoIds] = useState('');
  const [shapeName, setShapeName] = useState('');

  // == Event Handlers ==========================

  const onClose = () => {
    setShowPasteGeosModal(false);
  };

  const onSaveClicked = () => {
    const geoIds = pastedGeoIds.trim().split(/\r?\n/);

    const geoRequests = geoIds.map((geoId) => ({
      geoId: geoId,
      level: geoType,
    }));

    const shape = {
      groupId: selectedGroup.groupId,
      name: shapeName,
      level: geoType,
      geoRequests,
    };

    createShape(shape);
    setGeoType(null);
    setPastedGeoIds('');
    setShapeName('');
    onClose();
  };

  // == Component =================================

  return (
    <ModalPage
      maxWidth='xs'
      title='Paste Geo IDs'
      open={showPasteGeosModal}
      onClose={onClose}
      additionalActions={[
        {
          key: 'btnSave',
          text: 'Save',
          color: 'primary',
          onClick: () => {
            onSaveClicked();
          },
        },
        {
          key: 'btnClose',
          text: 'Close',
          color: 'primary',
          onClick: onClose,
        },
      ]}
    >
      <div className={classes.inputContainer}>
        <TextField
          value={shapeName}
          label='Name'
          InputProps={{
            shrink: 'true',
            className: classes.shapeNameInput,
          }}
          onChange={(e) => setShapeName(e.target.value)}
        />
        <Select
          value={geoType ?? 'none'}
          onChange={(e) => setGeoType(e.target.value)}
          label='Geo Type'
          name='geoType'
          className={classes.geoTypeDropDown}
        >
          {getShapeGeoTypes().map((type) => {
            return (
              <MenuItem key={type.value} value={type.value}>
                {type.caption}
              </MenuItem>
            );
          })}
        </Select>
      </div>

      <TextField
        className={classes.geoIdTextArea}
        value={pastedGeoIds}
        onChange={(e) => setPastedGeoIds(e.target.value)}
        label='Geo IDs'
        multiline
        rows={3}
        rowsMax={10}
        variant='outlined'
      />
    </ModalPage>
  );
};

// == Styles ==============================================

const styles = {
  geoTypeDropDown: {
    flexGrow: 1,
  },
  geoIdTextArea: {
    marginTop: 10,
    width: '100%',
  },
  shapeNameInput: {
    flexGrow: 1,
    marginRight: 10,
  },
  inputContainer: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'space-around',
  },
};

// == Connect =============================================

const mapStateToProps = ({ assumptionGroupsState }) => ({
  selectedGroup: assumptionGroupsState.selectedGroup,
  showPasteGeosModal: assumptionGroupsState.showPasteGeosModal,
});

const mapDispatchToProps = {
  setShowPasteGeosModal,
  createShape,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(PasteGeosModal);
